import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import { elements } from '../../../../styles.js'
import replaceWith from '@mailobj-browser/front/js/tree/replaceWith.js'
import { render } from '#utilities/js/template/template.js'
import globals from '#utilities/js/ea/globals.js'
import remove from '@mailobj-browser/front/js/tree/remove.js'

export const onMailModified = object(listener, {
  passive,
  task: (
    element
  ) => {
    const form = closest('form', element)
    const msgModified = one(`input[name='msg_modified']`, form)

    if (form) {
      const topbar = one(`.${elements.send_topbar}`, form)

      if (msgModified) {
        globals.ea_msg_mail_modified()
        msgModified.value = '1'
      }

      if (topbar) {
        actionCloseSwitch(topbar)
      }
    }
  }
})

export const actionCloseSwitch = (topbar) => {
  queueMicrotask(async () => {
    const template = one(`.${elements.send_topbar_close} > template`, topbar)

    if (template) {
      const button = await render(template)

      replaceWith(one(`.${elements.send_topbar_close} > a`, topbar), button)
      remove(template)
    }
  })
}
